import React from 'react';

/**
 * Individual chat message component
 * Displays either a user prompt or AI response (with optional image)
 */
function AiChatMessage({ message, onReplaceMain }) {
  const isUser = message.role === 'user';
  
  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4`}>
      <div
        className={`
          max-w-[80%] rounded-lg p-3
          ${isUser 
            ? 'bg-blue-500 text-white' 
            : 'bg-gray-100 text-gray-800'
          }
        `}
      >
        {/* Message text */}
        {message.text && (
          <p className="text-sm whitespace-pre-wrap">{message.text}</p>
        )}
        
        {/* AI generated image */}
        {message.imageUrl && (
          <div className="mt-2">
            <img
              src={message.imageUrl}
              alt="AI generated"
              className="max-w-full rounded-md shadow-md"
              style={{ maxHeight: '300px' }}
            />
            {/* Replace Main button for AI images */}
            {!isUser && onReplaceMain && (
              <button
                onClick={() => onReplaceMain(message)}
                className="
                  mt-2 px-3 py-1.5
                  text-xs font-medium
                  bg-green-500 hover:bg-green-600
                  text-white
                  rounded-md
                  shadow-sm hover:shadow-md
                  transition-all duration-200
                  flex items-center gap-1
                "
              >
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Replace Main Photo
              </button>
            )}
          </div>
        )}
        
        {/* Loading indicator for pending AI response */}
        {message.isLoading && (
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <div className="animate-spin w-4 h-4 border-2 border-purple-500 border-t-transparent rounded-full"></div>
            Generating...
          </div>
        )}
        
        {/* Timestamp */}
        {message.timestamp && (
          <p className={`text-xs mt-1 ${isUser ? 'text-blue-200' : 'text-gray-400'}`}>
            {new Date(message.timestamp).toLocaleTimeString()}
          </p>
        )}
      </div>
    </div>
  );
}

export default AiChatMessage;
